"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SearcherDateCarousel = _interopRequireDefault(require("../SearcherDateCarousel"));

var _excluded = ["children", "showSkeleton"];

var Arrow = function Arrow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 14.9L37 65l-21 50.1"
  }));
};

Arrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 130",
  fill: "none",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
};
var BADGE_WIDTH = 126;
var itemStyle = {
  width: BADGE_WIDTH
};
var StyledArrow = (0, _styledComponents["default"])(Arrow).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledArrow",
  componentId: "sc-11zwj95-0"
})(["position:absolute;cursor:pointer;width:40px;height:100px;padding:17px 0;top:-10px;z-index:2;background-image:linear-gradient(to right,rgba(255,255,255,0) 0%,", " 80%);border-radius:", ";path{stroke:", ";}"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return "0 ".concat(props.theme.shape.borderRadiusBig, " ").concat(props.theme.shape.borderRadiusBig, " 0");
}, function (props) {
  return props.theme.colors.greyLight;
});
var StyledPrevArrow = (0, _styledComponents["default"])(StyledArrow).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledPrevArrow",
  componentId: "sc-11zwj95-1"
})(["transform:rotate(180deg);left:", ";left:0;"], function (props) {
  return props.theme.shape.borderRadiusBig;
});
var StyledNextArrow = (0, _styledComponents["default"])(StyledArrow).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledNextArrow",
  componentId: "sc-11zwj95-2"
})(["transform:none;right:", ";right:0;"], function (props) {
  return props.theme.shape.borderRadiusBig;
});
var nextCls = 'swiper-button-custom-next';
var prevCls = 'swiper-button-custom-prev';
var StyledSearcherDateCarousel = (0, _styledComponents["default"])(_SearcherDateCarousel["default"]).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledSearcherDateCarousel",
  componentId: "sc-11zwj95-3"
})(["", ""], function (_ref) {
  var noSwiping = _ref.noSwiping;
  return noSwiping && "\n    .".concat(nextCls, ",\n    .").concat(prevCls, " {\n      visibility: hidden;\n    }\n  ");
});
var config = {
  navigation: {
    nextEl: ".".concat(nextCls),
    prevEl: ".".concat(prevCls)
  },
  renderPrevButton: function renderPrevButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledNextArrow, {
      className: nextCls
    });
  },
  renderNextButton: function renderNextButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledPrevArrow, {
      className: prevCls
    });
  }
};

var SearcherDateCarouselDesktop = function SearcherDateCarouselDesktop(_ref2) {
  var children = _ref2.children,
      showSkeleton = _ref2.showSkeleton,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledSearcherDateCarousel, (0, _extends2["default"])({}, config, {
    noSwiping: showSkeleton
  }, props), _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      dataIndex: index,
      style: itemStyle,
      showBackground: true,
      skeleton: showSkeleton
    });
  }));
};

SearcherDateCarouselDesktop.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  showSkeleton: _propTypes["default"].bool
};
SearcherDateCarouselDesktop.defaultProps = {
  className: '',
  showSkeleton: false
};

var _default = /*#__PURE__*/_react["default"].memo(SearcherDateCarouselDesktop);

exports["default"] = _default;